import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { DialogState } from './types';
import { RootState } from '../types';

export const state: DialogState = {
  show: false,
  cancel: false,
  message: '',
  callbackFn: null,
  cancelCallbackFn: null
};

const namespaced: boolean = true;

export const dialog: Module<DialogState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
